export default {"src":"/_next/static/media/v3-dog-icon.c738e2a1.svg","height":49,"width":48};